import { jsx as C } from "react/jsx-runtime";
function e(t) {
  return /* @__PURE__ */ C("svg", { fill: "none", height: "24", viewBox: "0 0 24 24", width: "24", xmlns: "http://www.w3.org/2000/svg", ...t, children: /* @__PURE__ */ C(
    "path",
    {
      d: "M19.2496 5.40902C18.0609 4.63678 17.2021 3.40032 16.935 1.95925C16.8776 1.64793 16.8456 1.32782 16.8456 1H13.0508L13.0442 16.1588C12.9802 17.8561 11.5784 19.2191 9.85982 19.2191C9.3256 19.2191 8.82227 19.086 8.37966 18.8539C7.36419 18.3215 6.66881 17.261 6.66881 16.04C6.66881 14.2865 8.1004 12.8608 9.85872 12.8608C10.1876 12.8608 10.5022 12.9147 10.8002 13.0082V9.14701C10.4923 9.1052 10.1788 9.0788 9.85872 9.0788C6.00764 9.0755 2.87402 12.1997 2.87402 16.0378C2.87402 18.393 4.05506 20.4776 5.85643 21.7382C6.99111 22.5325 8.37083 23 9.85982 23C13.712 23 16.8456 19.8769 16.8456 16.0378V8.35057C18.3346 9.41542 20.1581 10.0425 22.1261 10.0425V6.26046C21.0665 6.26046 20.0786 5.94585 19.2508 5.40792L19.2496 5.40902Z",
      fill: "white"
    }
  ) });
}
export {
  e as default
};
